import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWifiinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		d: "M66 18.828l-34 34-34-34C16.778.051 47.222.051 66 18.828z",
		id: "wifi-64px@1x-a"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "wifi-64px@1x-b",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#wifi-64px@1x-a" })
			}),
			/* @__PURE__ */ _jsx("circle", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round",
				mask: "url(#wifi-64px@1x-b)",
				cx: 32,
				cy: 55,
				r: 18
			}),
			/* @__PURE__ */ _jsx("circle", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round",
				mask: "url(#wifi-64px@1x-b)",
				cx: 32,
				cy: 55,
				r: 30
			}),
			/* @__PURE__ */ _jsx("circle", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round",
				mask: "url(#wifi-64px@1x-b)",
				cx: 32,
				cy: 55,
				r: 42
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				fill: "currentColor",
				mask: "url(#wifi-64px@1x-b)",
				cx: 32,
				cy: 53,
				rx: 4.923,
				ry: 4.6
			})
		]
	})]
});
export default SvgWifiinline;
